import _ from 'lodash';
import studentProfile from '../../../apis/studentProfile';
import {
  FatherColumnsOptions,
  MotherColumnsOptions,
  getStudentProfileColumnsOptions
} from '../config/constant';
import {
  transformedStudentDataForDownload,
  transformStudentData
} from './transformStudentData';

export const fetchAllStudentReportPages = async (params: any) => {
  const allData: any[] = [];
  const perPage = 400;
  let pageNo = 1;
  const BATCH_SIZE = 3;
  let hasMoreData = true;

  do {
    const pagePromises = [];
    for (let i = 0; i < BATCH_SIZE; i++) {
      pagePromises.push(
        studentProfile.fetchStudentReportApi(params, pageNo + i, perPage)
      );
    }

    const batchResults = await Promise.all(pagePromises);

    let foundEmpty = false;
    batchResults.forEach((result) => {
      const pageData = result || [];
      if (_.isEmpty(pageData)) {
        foundEmpty = true;
        return;
      }
      allData.push(...(pageData as any));
    });

    if (foundEmpty) {
      hasMoreData = false;
    } else {
      pageNo += BATCH_SIZE;
    }
  } while (hasMoreData);

  return allData;
};

export const getTransformedStudentData = (
  data: any[],
  isDownload: boolean,
  selectedColumns: string[],
  school: string
) => {
  const studentProfileColumns = getStudentProfileColumnsOptions(school);
  return isDownload
    ? transformedStudentDataForDownload(
        data,
        studentProfileColumns,
        FatherColumnsOptions,
        MotherColumnsOptions,
        selectedColumns
      )
    : transformStudentData(
        data,
        studentProfileColumns,
        FatherColumnsOptions,
        MotherColumnsOptions,
        selectedColumns
      );
};
